import { render, staticRenderFns } from "./main_residents_2.vue?vue&type=template&id=df03e4e6&scoped=true"
import script from "./main_residents_2.vue?vue&type=script&lang=js"
export * from "./main_residents_2.vue?vue&type=script&lang=js"
import style0 from "./main_residents_2.vue?vue&type=style&index=0&id=df03e4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df03e4e6",
  null
  
)

export default component.exports